import React from 'react';
import { Button } from '@framework-controls/core';
import { strings } from 'src/localization';
import css from './ServiceTabBtn.module.scss';
import classNames from 'classnames';
import { ButtonIds } from '../ServiceTab';

interface IProps {
    id: ButtonIds;
    label: string;
    selected: boolean;
    theme: string;
    onClick: (e: any) => void;
}

const CalendarSelectBtn = (props: IProps) => {
    const btnClassName = classNames(
        css.calBtn,
        {
            [css.calBtnChecked]: props.selected,
            [css.calBtnCS]: props.theme === 'colorSensitive',
            [css.calBtnCA]: props.theme === 'cadillac',
            [css.calBtnHonda]: props.theme === 'honda',
            [css.calBtnBuick]: props.theme === 'buick',
            [css.calBtnBMW]: props.theme === 'bmw',
            [css.calBtnFord]: props.theme === 'ford',
            [css.calBtnIN]: props.theme === 'infiniti',
            [css.calBtnMazda]: props.theme === 'mazda',
            [css.calBtnGenesis]: props.theme === 'genesis',
            [css.calBtnAcura]: props.theme === 'acura',
        },
    );

    let tooltip = '';
    if (props.id === ButtonIds.MaintMenu) {
        tooltip = strings.RecomMaintTip;
    }
    if (props.id === ButtonIds.IndSvcs) {
        tooltip = strings.ViewServcTip;
    }
    if (props.id === ButtonIds.WriteYour) {
        tooltip = strings.WriteYourOwnTip;
    }

    let label = props.label;
    if (props.theme === 'infiniti') {
        label = label.toLocaleLowerCase();
    }

    return (
        <div className={btnClassName}>
            <Button
                id={props.id + 'Btn'}
                onClick={props.onClick}
                variant='calBtn'
                disableRipple
                type={'text'}
                tooltip={tooltip}
            >
                <h3 className={css.calBtnContents}>{label}</h3>
            </Button>
        </div>
    );
};

export default CalendarSelectBtn;